import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import api from '../../../services/api';

import { IconInfoCircle } from '@tabler/icons';

import Header from '../../../components/Header';
import BottomNav from '../../../components/BottomNav';
import SearchInput from '../../../components/Form/SearchInput';
import SmallButton from '../../../components/SmallButton';
import UserItem from '../../../components/UserItem';

import { H2, Skeleton, NotFoundContainer } from '../../../components/Generic';
import { Container, Content, Row } from './styles';

import userImg from '../../../assets/images/user-avatar.png';

const SearchUser: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  const history = useHistory();

  const [scrollRadio, setScrollRadio] = useState(null);
  const scrollObserve = useRef<any>();

  useEffect(() => {
    handleSearch();

    intersectionObserver.observe(scrollObserve.current);

    return () => {
      intersectionObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (hasMore && scrollRadio) {
      loadMore();
    }
  }, [scrollRadio]);

  const intersectionObserver = new IntersectionObserver((entries: any) => {
    const radio = entries[0].intersectionRatio;
    setScrollRadio(radio);
  });

  const loadMore = async () => {
    if (loading) return;

    try {
      setLoadingMore(true);

      const response = await api.get(
        `/pesquisas/usuarios?limite=10&pagina=${page}&key=${query}`,
      );

      setUsers(users.concat(response.data.usuarios));

      const total = users.concat(response.data.usuarios).length;
      setHasMore(total < response.data.total);
      setPage(page + 1);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingMore(false);
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        `/pesquisas/usuarios?limite=10&pagina=1&key=${query}`,
      );

      setUsers(response.data.usuarios);

      const total = response.data.usuarios.length;
      setHasMore(total < response.data.total);
      setPage(2);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Header />

      <Content>
        <H2>Pesquisar</H2>
        <SearchInput
          placeholder="Digite o que procura"
          onSubmit={() => handleSearch()}
          onChange={(e: any) => setQuery(e.target.value)}
        />

        <Row>
          <SmallButton
            isActive={false}
            onClick={() => history.push('/pesquisar/propriedade')}
          >
            Propriedades
          </SmallButton>

          <SmallButton isActive={true}>Pessoas</SmallButton>
        </Row>

        <div style={{ marginTop: 40 }}>
          {loading ? (
            <LoadingComponent />
          ) : users?.length > 0 ? (
            users.map((item: any) => (
              <UserItem
                key={item.id}
                name={item.nome}
                avatar_url={item.url || userImg}
                description={item.email}
                onClick={() => history.push(`/usuario/${item.id}`)}
              />
            ))
          ) : (
            <NotFoundContainer>
              <IconInfoCircle
                size={25}
                color="#999"
                style={{ marginRight: 20 }}
              />

              <strong>Nenhum usuário encontrado.</strong>
            </NotFoundContainer>
          )}
        </div>

        <div ref={scrollObserve} />

        {loadingMore && <LoadingComponent />}
      </Content>

      <BottomNav selected="search" />
    </Container>
  );
};

const LoadingComponent = () => (
  <>
    <Skeleton style={{ height: 60, width: '100%', marginBottom: 20 }} />
    <Skeleton style={{ height: 60, width: '100%', marginBottom: 20 }} />
    <Skeleton style={{ height: 60, width: '100%', marginBottom: 20 }} />
  </>
);

export default SearchUser;
